<!-- the AI Cost Calculator card (owner 2026-10-19): the questions at the left, the bill at the right; on the
     calculator page (the table below it) and in the home page's tools box -->
<div class="acw-card">
  <div class="acw-inputs">
    <div class="acw-field">
      <span class="acw-label">What Are You Building</span>
      <app-cg-select class="acw-dd" [options]="scenarioOptions" [value]="scenario.key" ariaLabel="What are you building"
                     (valueChange)="setScenarioKey( $event )"></app-cg-select>
    </div>
    <label class="acw-field" *ngFor="let f of mainFields">
      <span class="acw-label">{{ f.label }}</span>
      <span class="acw-num">
        <input class="acw-input" type="number" [min]="f.min" [max]="f.max" [step]="f.step" [ngModel]="shown( f )" (ngModelChange)="setValue( f, $event )" inputmode="numeric">
        <span class="acw-steps">
          <button type="button" class="acw-step acw-step-up" (click)="nudge( f, 1, $event )" [attr.aria-label]="'More ' + f.label"></button>
          <button type="button" class="acw-step acw-step-down" (click)="nudge( f, -1, $event )" [attr.aria-label]="'Less ' + f.label"></button>
        </span>
      </span>
      <span class="acw-hint">{{ f.hint }}<ng-container *ngIf="f.words"> · {{ tokenNote( f ) }}</ng-container></span>
    </label>
    <!-- the finer settings, folded under the questions (owner 2026-10-19: inside the card, not a section) -->
    <details class="acw-more" (toggle)="onMoreToggle( $event )">
      <summary>More Options</summary>
      <label class="acw-field" *ngFor="let f of moreFields">
        <span class="acw-label">{{ f.label }}</span>
        <span class="acw-num">
        <input class="acw-input" type="number" [min]="f.min" [max]="f.max" [step]="f.step" [ngModel]="shown( f )" (ngModelChange)="setValue( f, $event )" inputmode="numeric">
        <span class="acw-steps">
          <button type="button" class="acw-step acw-step-up" (click)="nudge( f, 1, $event )" [attr.aria-label]="'More ' + f.label"></button>
          <button type="button" class="acw-step acw-step-down" (click)="nudge( f, -1, $event )" [attr.aria-label]="'Less ' + f.label"></button>
        </span>
      </span>
        <span class="acw-hint">{{ f.hint }}</span>
      </label>
    </details>
  </div>

  <div class="acw-out" aria-live="polite">
    <ng-container *ngIf="chosen as c; else loading">
      <span class="acw-eyebrow">Per Month</span>
      <span class="acw-bill">{{ money( c.perMonth ) }}</span>
      <p class="acw-for">for {{ usage }} on</p>
      <app-cg-select class="acw-dd acw-model" [options]="modelOptions" [value]="c.model.id" ariaLabel="Model"
                     (valueChange)="pickModelId( $event )"></app-cg-select>
      <div class="acw-chips">
        <span class="acw-chip">{{ money( c.perDay ) }} a Day</span>
        <span class="acw-chip">{{ money( c.perRequest ) }} per {{ scenario.one }}</span>
        <ng-container *ngIf="cheapest as low">
          <span class="acw-chip acw-cheap" *ngIf="low.model.id === c.model.id">The Cheapest Model</span>
          <button type="button" class="acw-chip acw-cheap" *ngIf="low.model.id !== c.model.id" (click)="pickModel( low )">
            Cheapest: {{ low.model.name }} {{ money( low.perMonth ) }}
          </button>
        </ng-container>
      </div>
      <span class="acw-foot">{{ data?.models?.length }} models on {{ platformKeys.length }} platforms, prices as of {{ syncedDay }}</span>
    </ng-container>
    <ng-template #loading><span class="acw-eyebrow">Loading the prices</span></ng-template>
  </div>
</div>
